import React, { FC, ChangeEvent } from 'react'

import ReactTextMask from 'react-text-mask'

import classes from './masked-input.module.scss'

export interface MaskedInputProps {
  inputLength: number
  prefix?: string
  value: string
  onChange: (value: string) => void
  inputAlt: string
  inputName: string
  allowedCharRegex?: RegExp
}

const PLACEHOLDER = '_'

const createMask = (length: number, allowedCharRegex: RegExp): RegExp[] =>
  Array<RegExp>(length).fill(allowedCharRegex)

export const MaskedInput: FC<MaskedInputProps> = ({
  inputLength,
  prefix,
  value,
  onChange,
  inputAlt,
  inputName,
  allowedCharRegex = /[0-9]/,
}) => (
  <div className={classes.container}>
    {prefix && <div className={classes.prefix}>{prefix}</div>}
    <ReactTextMask
      className={classes.input}
      aria-label={inputAlt}
      name={inputName}
      type="text"
      mask={createMask(inputLength, allowedCharRegex)}
      placeholder={PLACEHOLDER.repeat(inputLength)}
      placeholderChar={PLACEHOLDER}
      guide
      value={value}
      onChange={(ev: ChangeEvent<HTMLInputElement>) => {
        onChange(ev.currentTarget.value.replace(/_/g, ''))
      }}
    />
  </div>
)

export default MaskedInput
